import { Helpers } from '../../helpers';
import { IAreaTeam } from '../../interfaces/iarea-team';
import { Area } from '../area';
import { AreaTeamAvailability } from '../area-team-availability';
import { Rig } from '../rig';
import { Well } from '../well';

export class AreaTeamBase {
  AreaTeamId: number;
  Description: string;
  SortOrder: number | null;
  Shape: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_AreaTeam?: Array<Area> | null;
  AreaTeamAvailabilities_AreaTeam?: Array<AreaTeamAvailability> | null;
  Rigs_AreaTeam?: Array<Rig> | null;
  Wells_AreaTeam?: Array<Well> | null;

  constructor(item?: IAreaTeam) {
    if (item) {

      this.AreaTeamId = item.AreaTeamId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Shape = item.Shape;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_AreaTeam = Helpers.createClassArray(Area, item.Areas_AreaTeam);
      this.AreaTeamAvailabilities_AreaTeam = Helpers.createClassArray(AreaTeamAvailability, item.AreaTeamAvailabilities_AreaTeam);
      this.Rigs_AreaTeam = Helpers.createClassArray(Rig, item.Rigs_AreaTeam);
      this.Wells_AreaTeam = Helpers.createClassArray(Well, item.Wells_AreaTeam);
    }
  }
}